module.exports = __webpack_public_path__ + "static/media/costcontrol1.55d25c76.png";